export const IntroTextWidgetId = 'IntroTextWidget';

export enum IntroTextWidgetAttributes {
  HEADLINE = 'headline',
  COMPONENT = 'component',
  TEXT = 'text',
  ID = 'idIntroText',
}
